import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { isEmpty, cloneDeep, sortBy } from 'lodash';
import moment from 'moment';
import PageTitle from '../../../../components/PageTitle';
import RouteNames from '../../../App/RouteNames';
import {
  uploadMultiPartFiles,
  saveOutputTemplateByType,
  getOutputTemplateByType,
  getConfigOrganization,
} from '../../../App/actions';
import TitleFrom from '../../../../components/common/TitleFrom';
import { BroadsoftZeroDurationCdrsSearchForm } from '../../../../components/ReportHub';
import {
  SwitchExport,
  DataTable,
  ExcelExport,
  TablePagination,
  ButtonExport,
  EmailGroup,
  DragDropConfigExportTemplate,
  ModalWithItem,
} from '../../../../components/common';
import { tabelColumnExportBroadsoftZeroDurationCdrs, sortBroadsoftZeroDurationCdrs } from '../../constants';
import {
  getBroadsoftZeroDurationCdrsReport,
  getAllBroadsoftZeroDurationCdrsReport,
  onResetDefaultData,
} from '../../actions';
import { makeGetListBroadsoftZeroDurationCdrst, makeGetListAllBroadsoftZeroDurationCdrst } from '../../selectors';
import {
  getPageTotalCount,
  parseToMutationRequestPostMethod,
  blobToFile,
  validateEmail,
  blobToCSVFile,
  configOutputTemplateByType,
} from '../../../../utils/utils';
import convertJson2Sheet from '../../../../utils/ExcelHelper/exportExcelFile';
import convertJson2Pdf from '../../../../utils/PdfHelper/exportPdfFile';
import { PAGE_SIZE_DOWNLOAD } from '../../../../utils/constants';

let tableColumnsOutput = null;
class BroadsoftZeroDurationCdrs extends Component {
  state = {
    isActivePdf: false,
    page: 0,
    size: 20,
    filter: {},
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
    listBroadsoftZeroDurationCdrs: [],
    configOrganizationOption: [],
  };

  buttonRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    return {
      listBroadsoftZeroDurationCdrs: props.listBroadsoftZeroDurationCdrs,
      totalCount: getPageTotalCount({ ...state, items: props.listBroadsoftZeroDurationCdrs }),
    };
  }

  componentDidMount() {
    const {
      permissions: { modeGetBroadsoftZeroDurationCdrs },
      onResetDefaultData,
      getConfigOrganization,
    } = this.props;
    if (modeGetBroadsoftZeroDurationCdrs) {
      this.doGetOutputTemplateByType();
      onResetDefaultData('listBroadsoftZeroDurationCdrst');
      getConfigOrganization('', ({ success, data }) => {
        if (success) {
          let configOrganizationOption = [];
          if (data && data.configOrganizationList && data.configOrganizationList.length) {
            configOrganizationOption = data.configOrganizationList.map(val => {
              return { label: val.value, value: val.value };
            });
          }
          this.setState({
            configOrganizationOption:
              configOrganizationOption && configOrganizationOption.length
                ? sortBy(configOrganizationOption, ['label'])
                : [],
          });
        }
      });
    }
  }

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => {
      this.doGetListBroadsoftZeroDurationCdrs();
    });
  };

  onPageChange = pageChange => {
    const { page } = this.state;
    if (page === pageChange) return '';
    return this.setState({ page: pageChange }, () => this.doGetListBroadsoftZeroDurationCdrs());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doGetListBroadsoftZeroDurationCdrs());
  };

  onHandleSubmitSearch = filter => {
    this.setState({ filter: { ...filter }, page: 0 }, () => {
      this.doGetListBroadsoftZeroDurationCdrs();
    });
  };

  doGetListBroadsoftZeroDurationCdrs = () => {
    const { filter, page, size, sorted } = this.state;
    const newFilter = cloneDeep(filter);
    if (!newFilter.startDate) {
      newFilter.startDate = moment()
        .startOf('month')
        .format('YYYY-MM-DD HH:mm:ss');
    }
    if (!newFilter.endDate) {
      newFilter.endDate = moment()
        .endOf('month')
        .format('YYYY-MM-DD HH:mm:ss');
    }
    if (!newFilter.switchName) {
      newFilter.switchName = 'BROADSOFT';
    }
    const { getBroadsoftZeroDurationCdrsReport, id } = this.props;
    if (id) filter.accountId = id;
    const payload = {
      page: page + 1,
      size,
      filter: newFilter,
      sort:
        !isEmpty(sorted) && sortBroadsoftZeroDurationCdrs[sorted.sortCol]
          ? sortBroadsoftZeroDurationCdrs[sorted.sortCol][sorted.sortDir]
          : null,
    };
    this.setState({ isSearching: true });
    getBroadsoftZeroDurationCdrsReport(payload, () => {
      this.setState({ isSearching: false });
    });
  };

  doGetAlllistBroadsoftZeroDurationCdrs = cb => {
    const { filter, sorted } = this.state;
    const newFilter = cloneDeep(filter);
    if (!newFilter.startDate) {
      newFilter.startDate = moment()
        .startOf('month')
        .format('YYYY-MM-DD HH:mm:ss');
    }
    if (!newFilter.endDate) {
      newFilter.endDate = moment()
        .endOf('month')
        .format('YYYY-MM-DD HH:mm:ss');
    }
    if (!newFilter.switchName) {
      newFilter.switchName = 'BROADSOFT';
    }
    const { getAllBroadsoftZeroDurationCdrsReport, id } = this.props;
    if (id) filter.accountId = id;
    const payload = {
      page: 1,
      size: PAGE_SIZE_DOWNLOAD,
      filter: newFilter,
      sort: !isEmpty(sorted) ? sortBroadsoftZeroDurationCdrs[sorted.sortCol][sorted.sortDir] : null,
    };
    getAllBroadsoftZeroDurationCdrsReport(payload, () => {
      if (cb) cb();
    });
  };

  onChangeSwitch = () => {
    const { isActivePdf } = this.state;
    this.setState({ isActivePdf: !isActivePdf });
  };

  onExport = () => {
    this.doGetAlllistBroadsoftZeroDurationCdrs(() => {
      const { isActivePdf } = this.state;
      if (isActivePdf) {
        const { listAllBroadsoftZeroDurationCdrs, t } = this.props;
        convertJson2Pdf({
          data: listAllBroadsoftZeroDurationCdrs,
          t,
          title: t('reportPage:sidebar.rawBroadsoftZeroDurationCDR').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.rawBroadsoftZeroDurationCDR')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          columnsTable: tableColumnsOutput,
          fontSize: 3,
        });
      } else {
        this.buttonRef.current.click();
      }
    });
  };

  sendEmail = ({ subject, emailBody }) => {
    this.doGetAlllistBroadsoftZeroDurationCdrs(() => {
      const { listAllBroadsoftZeroDurationCdrs, t, uploadMultiPartFiles } = this.props;
      const { emails, isActivePdf } = this.state;

      const query = `{"query": "mutation{sendReport(input: ${parseToMutationRequestPostMethod(
        {
          emailAddress: emails.join(', '),
          type: 'GET_RAW_CDR_REPORT',
          subject: subject || `Embrix Report ${t('reportPage:sidebar.rawBroadsoftZeroDurationCDR')}`,
          emailBody,
        },
        ['type']
      )})}"}`;
      const formData = new FormData();

      if (!isActivePdf) {
        formData.append(
          'file',
          blobToCSVFile({
            fileName: `${t('reportPage:sidebar.rawBroadsoftZeroDurationCDR')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}.csv`,
            data: listAllBroadsoftZeroDurationCdrs,
            t,
            columns: tableColumnsOutput,
          })
        );
      } else {
        const pdfFile = convertJson2Pdf({
          data: listAllBroadsoftZeroDurationCdrs,
          t,
          title: t('reportPage:sidebar.rawBroadsoftZeroDurationCDR').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.rawBroadsoftZeroDurationCDR')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          isFile: true,
          columnsTable: tableColumnsOutput,
          fontSize: 3,
        });
        formData.append(
          'file',
          blobToFile(
            pdfFile,
            `${t('reportPage:sidebar.rawBroadsoftZeroDurationCDR')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`
          )
        );
      }

      formData.append('graphql', query);
      // formData.append('file', blobToFile(pdfFile, 'attachment'));
      uploadMultiPartFiles(
        formData,
        res => {
          if (res && res.success) {
            if (res.success) this.setState({ emails: [] });
          }
        },
        true
      );
    });
  };

  onChangeEmail = tags => {
    let isEmail = true;
    if (tags && tags.length) {
      tags.forEach(email => {
        if (!validateEmail(email)) {
          isEmail = false;
        }
      });
    }
    if (!isEmail) return '';

    return this.setState({ emails: tags });
  };

  doGetOutputTemplateByType = () => {
    const { getOutputTemplateByType, t } = this.props;
    getOutputTemplateByType('RAW_BROADSOFT_ZERO_DURATION_CDR_REPORT', ({ success, data }) => {
      if (success && data) {
        this.setState({
          exportColumnsSave: configOutputTemplateByType({
            columns: tabelColumnExportBroadsoftZeroDurationCdrs,
            data,
            t,
          }),
          idOutputTemplate: data?.id,
          typeOutputTemplate: data?.type,
        });
      }
    });
  };

  onHandleSaveConfig = columns => {
    const { saveOutputTemplateByType } = this.props;
    const { idOutputTemplate, typeOutputTemplate } = this.state;
    const payload = {
      id: idOutputTemplate,
      type: typeOutputTemplate,
      source: columns.sourceFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
      target: columns.targetFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
    };

    saveOutputTemplateByType(payload, ({ success }) => {
      if (success) {
        this.doGetOutputTemplateByType();
        this.setState({ exportColumnsSave: columns, isOpenModalExportConfig: false });
      }
    });
  };

  onToggleModalExportConfig = () => {
    const { isOpenModalExportConfig } = this.state;
    this.setState({ isOpenModalExportConfig: !isOpenModalExportConfig });
  };

  render() {
    const {
      isSearching,
      isActivePdf,
      sorted,
      page,
      size,
      totalCount,
      listBroadsoftZeroDurationCdrs,
      emails,
      exportColumnsSave,
      isOpenModalExportConfig,
      configOrganizationOption,
    } = this.state;
    const {
      listAllBroadsoftZeroDurationCdrs,
      t,
      permissions: { modeGetBroadsoftZeroDurationCdrs, modeDownloadReport, modeGetMailReport },
    } = this.props;
    if (!modeGetBroadsoftZeroDurationCdrs) return '';
    const exportColumns = exportColumnsSave || {};
    tableColumnsOutput = exportColumns?.targetFields?.items || [];
    return (
      <div className="col-md-12">
        <PageTitle
          linkTo={RouteNames.report.path}
          titleBtn="back"
          items={[
            { name: t('label.report'), url: RouteNames.report.path },
            { name: t('reportPage:sidebar.rawBroadsoftZeroDurationCDR') },
          ]}
        />
        <br />
        <div className="card card-statistics mb-30">
          <TitleFrom title={t('reportPage:sidebar.rawBroadsoftZeroDurationCDR')} />
          <div className="col-md-12 mb-30">
            <div className="card-body">
              <div className="pl-2">
                <BroadsoftZeroDurationCdrsSearchForm
                  onSubmit={this.onHandleSubmitSearch}
                  isMultipleOptionInject
                  optionsInject={{
                    clientName: configOrganizationOption,
                  }}
                />
              </div>
              <div>
                <div className="mt-3 col-md-12 row mb-4 pt-3 pb-3">
                  <button
                    type="submit"
                    onClick={this.onToggleModalExportConfig}
                    className="button x-small mr-2 btn-config"
                  >
                    <i className="ti-list" />
                  </button>
                  {!!modeDownloadReport && (
                    <div className="ml-auto mt-2 mb-auto mr-3">
                      <SwitchExport
                        onChange={this.onChangeSwitch}
                        wrapperClass={isActivePdf ? 'switch-active' : 'switch-non-active'}
                        title={t('label.excel')}
                        checked={isActivePdf}
                        rightTitle={t('label.pdf')}
                      />
                    </div>
                  )}
                  {!!modeDownloadReport && (
                    <>
                      <ButtonExport onExport={this.onExport} />
                      <ExcelExport
                        element={<button type="button" className="display-none" ref={this.buttonRef} />}
                        nameSheet={t('reportPage:sidebar.rawBroadsoftZeroDurationCDR').toLocaleUpperCase()}
                        multiDataSet={convertJson2Sheet({
                          data: listAllBroadsoftZeroDurationCdrs,
                          t,
                          title: t('reportPage:sidebar.rawBroadsoftZeroDurationCDR').toLocaleUpperCase(),
                          columnsTable: tableColumnsOutput,
                        })}
                        fileName={`${t('reportPage:sidebar.rawBroadsoftZeroDurationCDR')
                          .toLocaleLowerCase()
                          .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`}
                      />
                    </>
                  )}
                  {modeGetMailReport !== 0 && (
                    <EmailGroup
                      emails={emails}
                      onChangeEmail={this.onChangeEmail}
                      sendEmail={this.sendEmail}
                      data={listBroadsoftZeroDurationCdrs}
                    />
                  )}
                </div>
                <DataTable
                  columns={tableColumnsOutput}
                  data={
                    listBroadsoftZeroDurationCdrs && listBroadsoftZeroDurationCdrs.length
                      ? listBroadsoftZeroDurationCdrs
                      : []
                  }
                  onSort={this.onSortColumn}
                  sorted={sorted}
                  isLoading={isSearching}
                  isFixedHeaderTable
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
        <ModalWithItem
          onToggle={this.onToggleModalExportConfig}
          isOpen={isOpenModalExportConfig}
          wrapperClass="modal-config"
        >
          <div className="col-md-12 d-flex">
            <div className="column-config" onClick={this.onToggleModalExportConfig} />
            <div className="body-config">
              <DragDropConfigExportTemplate
                onHandleSave={this.onHandleSaveConfig}
                exportColumns={exportColumns}
                onToggle={this.onToggleModalExportConfig}
              />
            </div>
          </div>
        </ModalWithItem>
      </div>
    );
  }
}

BroadsoftZeroDurationCdrs.propTypes = {
  getBroadsoftZeroDurationCdrsReport: PropTypes.func,
  getAllBroadsoftZeroDurationCdrsReport: PropTypes.func,
  listAllBroadsoftZeroDurationCdrs: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.any),
    PropTypes.objectOf(PropTypes.any),
  ]),
};

BroadsoftZeroDurationCdrs.defaultProps = {
  getBroadsoftZeroDurationCdrsReport: () => {},
  getAllBroadsoftZeroDurationCdrsReport: () => {},
  listAllBroadsoftZeroDurationCdrs: [],
};

const mapStateToProps = createStructuredSelector({
  listBroadsoftZeroDurationCdrs: makeGetListBroadsoftZeroDurationCdrst() || [],
  listAllBroadsoftZeroDurationCdrs: makeGetListAllBroadsoftZeroDurationCdrst() || [],
});
export default withTranslation('common')(
  connect(mapStateToProps, {
    getBroadsoftZeroDurationCdrsReport,
    getAllBroadsoftZeroDurationCdrsReport,
    uploadMultiPartFiles,
    saveOutputTemplateByType,
    getOutputTemplateByType,
    onResetDefaultData,
    getConfigOrganization,
  })(BroadsoftZeroDurationCdrs)
);
